module.exports = __webpack_public_path__ + "img/theatre_3.79ef66fa.jpg";